import { stringify } from "querystring"
import { useMemo } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import useSWR from "swr"

export type StoreInList = {
  id: number
  name: string
  companyName: string
  customerAcquisitionSupportEnabled: boolean
  inStoreUsageEnabled: boolean
  storeAuth?: {
    effective_now: boolean
  }
}

type Pagination = {
  current_page: number
  limit_value: number
  total_count: number
  total_pages: number
}

export const useStoresSWR = () => {
  const query = {
    page: 1,
    per: 100000, // 現状はページネーションをしていないし、ならとりあえずここまではいかないであろうという値を設定しておきます
  }

  const url = useMemo(
    () => `${SMOOTH_LINE_API_URL}/base_api/smoother/stores?${stringify(query)}`,
    [query]
  )
  const { getWithToken } = useSmoothApi()

  const fetcher = async () => {
    const res = await getWithToken(url)
    const data = res.data as {
      stores: StoreInList[]
      pagination: Pagination
    }
    return data
  }

  const storesSwr = useSWR(url, fetcher, {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  })

  return {
    storesSwr,
  }
}
